import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import { InvalidInputException } from 'src/errors/CustomErrors';
import { DimensionSpecs } from 'src/utils/Types';
import { validateBaselineJpeg, validateImageDimensions } from 'src/utils/validations/Images';

import {
  AbstractAssetInputHandler,
  AbstractAssetInputHandlerProps,
} from './AbstractAssetInputHandler';

interface ImageInputHandlerProps extends AbstractAssetInputHandlerProps {}

class ImageInputHandler extends AbstractAssetInputHandler {
  constructor(props: ImageInputHandlerProps) {
    super(props);
  }

  protected async validateFileObject(fileObject: File, specs: DimensionSpecs): Promise<void> {
    switch (this.assetType) {
      case AssetType.BACKGROUND_IMAGE:
        await Promise.all([
          validateImageDimensions(fileObject, specs),
          validateBaselineJpeg(fileObject),
        ]);
        break;

      case AssetType.LOGO:
        await validateImageDimensions(fileObject, specs);
        break;

      default:
        throw new InvalidInputException(
          `Unsupported asset type passed in ImageInputHandler: ${this.assetType}`,
        );
    }
  }
}

export { ImageInputHandler };
